import "./i18n";
import React, { Suspense, useEffect } from "react";
import { AppHeader } from "./components/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastProvider } from "@veneer/core";
import { ThemeProvider } from "@veneer/theme";
import SessionManager from "./utils/session";
import { tracker } from "./utils/interactionTracking";
import { useSelector } from "react-redux";

const DashboardPage = React.lazy(() => import("./Pages/Dashboard"));
const ExplorePage = React.lazy(() => import("./Pages/Explore"));
const ShopPage = React.lazy(() => import("./Pages/Shop"));
const SupportPage = React.lazy(() => import("./Pages/Support"));
const AdminPage = React.lazy(() => import("./Pages/Admin"));

function App() {
  const localeId = useSelector((state: any) => state.region.localeId);
  
  useEffect(() => {
    const sessionId = SessionManager.getInstance().getSessionId();

    const handleUnload = () => {
      const interactionsData = tracker.getFlatEvents();
      if(Object.keys(interactionsData).length===0) return;
      const payload = JSON.stringify({
        sessionId,
        interactions: interactionsData,
        locale: localeId ?? ""
      });
      navigator.sendBeacon(
        `${window.env.SERVER_URL}/api/v1/admin/analytics/logclientinteraction`,
        new Blob([payload], {type: 'application/json'})
      );
      tracker.clearEvents()
      };
      window.addEventListener('beforeunload', handleUnload);
      return () => {
        window.removeEventListener('beforeunload', handleUnload);
      };
  }, [localeId]);
  return (
    <div className="App">
      <ThemeProvider>
        <ToastProvider>
          <BrowserRouter>
            <AppHeader />
            <Suspense>
              <Routes>
                <Route path="/" Component={DashboardPage} />
                <Route path="/dashboard" Component={DashboardPage} />
                <Route path="/explore" Component={ExplorePage} />
                <Route path="/shop" Component={ShopPage} />
                <Route path="/support" Component={SupportPage} />
                <Route path="/admin" Component={AdminPage} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </ToastProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;